export default __webpack_public_path__ + "static/media/1-3-4.624a5a12.jpg";